<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TheProject',
}
</script>

<style scoped></style>
